<!-- Quick stats boxes -->
<div class="row">

    <div class="col-lg-3">

        <!-- Current server load -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">21,041</h3>
                <strong>Monthly Committed Members</strong>
                <div class=" text-size-small">20 defaulted members </div>
            </div>

            <div id="server-load"></div>
        </div>
        <!-- /current server load -->

    </div>

    <div class="col-lg-3">

        <!-- Members online -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">42,180</h3>
                <strong>Weekly Committed Members</strong>
                <div class="text-size-small">80 defaulted members</div>
            </div>

            <div class="container-fluid">
                <div id="members-online"></div>
            </div>
        </div>
        <!-- /members online -->

    </div>



    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">4,201</h3>
                <strong>Daily Committed Members</strong>
                <div class="text-size-small">12 defaulted members</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->
    </div>


    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-700">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">67,423</h3>
                <strong>Total Committed members</strong>
                <div class="text-size-small">Total Defaulted members - 112</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>

</div>
<!-- /quick stats boxes -->


<div class="row">

    <div class="col-md-8">
        <div style="padding:15px;" class="panel panel-flat">
            <div class="content-group text-center">

                <fusioncharts [chartConfig]=pieConfig type="pie3d" [dataSource]="pieDataSource">
                </fusioncharts>

            </div>
        </div>
    </div>
</div>